module.exports = __webpack_public_path__ + "mz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mz.svg
// module id = 975
// module chunks = 0